import PropTypes from 'prop-types';
import React from 'react';
import UserDetailsBasicInfo from 'components/users/UserDetailsBasicInfo';
import UserDetailsRow from 'components/users/UserDetailsRow';
import UserDetailsElement from 'components/users/UserDetailsElement';
import DetailsAddress from 'components/DetailsAddress';
import { can } from '../../../../../services';
import BasicInfoStyling from './installerBasicInfoDetails.scss';


const MINIMUM_LINE_ITEMS = [
  { number: 227605, label: 'Minimum Charge - Tile' },
  { number: 227614, label: 'Minimum Charge - Laminate' },
  { number: 227637, label: 'Minimum Charge - Hardwood' },
  { number: 227647, label: 'Minimum Charge - Vinyl' },
  { number: 228214, label: 'Minimum Charge - Carpet' },
  { number: 475371, label: 'Minimum Charge - Backsplash' },
];
const EMPTY_DETAIL = { price_cents: ' -- ' };
const DEFAULT_ADDRESS = { street: '', city: '', state: '', zip_code: '' };

const InstallerBasicInfoDetails = (props) => {
  const { installer, installer: {
    address = DEFAULT_ADDRESS,
    workers_comp_expiration = null,
    liability_insurance_expiration = null,
    net_payable_exempt = null,
    is_self_schedulable = false,
    pay_details = [],
    visibility = null,
    assigned_supervisor = null,
    supervisor_name = null, // backward compatibility
    overall_percentage = null,
    custom_labor_percentage = null,
  }, role, position = '', mvw = {} } = props;
  const safeAddress = address || DEFAULT_ADDRESS;

  const supervisorName = (assigned_supervisor && assigned_supervisor.name) || supervisor_name;


  const renderMinimums = payDetails => MINIMUM_LINE_ITEMS.map((lineItem) => {
    const detail = payDetails.length ?
      payDetails.find(p => Number(p.item_number) === lineItem.number) || EMPTY_DETAIL :
      EMPTY_DETAIL;
    const convertCentsToDollars = isNaN(detail.price_cents) ?
    EMPTY_DETAIL.price_cents : detail.price_cents / 100;
    return (
      <UserDetailsElement
        key={lineItem.number}
        title={lineItem.label}
        value={convertCentsToDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
      />);
  });

  return (<div>
    <UserDetailsBasicInfo user={installer} />
    <UserDetailsRow title="Company Details">
      <UserDetailsElement title="address">
        <DetailsAddress
          address={safeAddress.street}
          city={safeAddress.city}
          state={safeAddress.state}
          zipCode={safeAddress.zip_code}
        />
      </UserDetailsElement>
    </UserDetailsRow>
    <UserDetailsRow title="Insurance">
      <UserDetailsElement
        title="workers comp. expiration"
        value={workers_comp_expiration}
      />
      <UserDetailsElement
        title="general liability insurance expiration"
        value={liability_insurance_expiration}
      />
    </UserDetailsRow>
    <UserDetailsRow title="Payment Details">
      <UserDetailsElement
        title="Exempt Net Payable Reduction"
        value={net_payable_exempt ? 'Yes' : 'No'}
      />
      <div className={BasicInfoStyling.MinProjectPriceContainer}>
        <div className={BasicInfoStyling.MinProjectPrice}>
          {renderMinimums(pay_details)}
        </div>
      </div>
    </UserDetailsRow>
    <UserDetailsRow title="Scheduling">
      <UserDetailsElement
        title="Self Schedulable"
        value={is_self_schedulable ? 'Yes' : 'No'}
      />
    </UserDetailsRow>
    {role !== 'installer' && <UserDetailsRow title="Restrictions">
      <UserDetailsElement
        title="Schedule Visibility"
        value={`${visibility || '1'} Day(s)`}
      />
    </UserDetailsRow>}
    {mvw.ifi && (
      <UserDetailsRow title="IFI Pay">
        <UserDetailsElement
          title="Overall %"
          value={overall_percentage != null ? `${overall_percentage}%` : '--'}
        />
        <UserDetailsElement
          title="Custom Labor %"
          value={custom_labor_percentage != null ? `${custom_labor_percentage}%` : '--'}
        />
      </UserDetailsRow>
    )}
    {can(role, 'view', 'SUPERVISOR_INFO', {
      position,
      mvw,
    }) && supervisorName && (
      // "Supervisor" is labeled as "Coordinator" in the UI since
      // that's more familiar to IFI users, but the value is still
      // stored as "supervisor_id" in the backend.
      <UserDetailsRow title="Coordinator">
        <UserDetailsElement
          title="Assigned Coordinator"
          value={supervisorName}
        />
      </UserDetailsRow>
    )}
  </div>);
};

InstallerBasicInfoDetails.propTypes = {
  installer: PropTypes.object,
  role: PropTypes.string,
  position: PropTypes.string,
  mvw: PropTypes.object,
};

export default InstallerBasicInfoDetails;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerBasicInfoDetails.jsx